/**
 * Subscription plans. Monthly price × duration × discount tier.
 * Mock only — no backend wiring yet. Change values freely.
 *
 * Durations: 3 / 6 / 12 months as per Phase 1 requirements.
 * Currency stored as a code + formatter friendly amount (no floating math
 * in the render path — product should eventually pull from Stripe).
 */
export const CURRENCY = {
  code: "CHF",
  symbol: "CHF ",
};

export const PLANS = [
  {
    id: "essential-3",
    months: 3,
    priceTotal: 24,         // full amount charged up front
    pricePerMonth: 8,
    badge: null,
    features: [
      "feature.channels_12k",
      "feature.vod_library",
      "feature.fhd_1080p",
      "feature.two_devices",
      "feature.seven_day_epg",
    ],
  },
  {
    id: "cinema-6",
    months: 6,
    priceTotal: 42,
    pricePerMonth: 7,
    badge: "plans.badge.popular",
    featured: true,
    features: [
      "feature.channels_12k",
      "feature.vod_library",
      "feature.uhd_4k",
      "feature.three_devices",
      "feature.fourteen_day_epg",
      "feature.priority_support",
    ],
  },
  {
    id: "premiere-12",
    months: 12,
    priceTotal: 72,
    pricePerMonth: 6,
    badge: "plans.badge.best_value",
    features: [
      "feature.channels_12k",
      "feature.vod_library",
      "feature.uhd_4k",
      "feature.five_devices",
      "feature.fourteen_day_epg",
      "feature.priority_support",
      "feature.early_access",
    ],
  },
];

export function formatPrice(amount, currency = CURRENCY) {
  return `${currency.symbol}${amount}`;
}
